import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';
import style from './IsUseCustomerTipsCheckBox.module.scss';

interface IIsUseCustomerTipsCheckBox {
	toggleIsUsedCustomerTips: () => void;
	isUsedCustomerTips: boolean;
}

const IsUseCustomerTipsCheckBox: React.FC<IIsUseCustomerTipsCheckBox> = ({
	toggleIsUsedCustomerTips,
	isUsedCustomerTips,
}) => {
	return (
		<Form.Item className={style.container} name="isUsedCustomerTips">
			<Checkbox checked={isUsedCustomerTips} onChange={toggleIsUsedCustomerTips}>
				<Text translationNameSpace="form" translationKey="isUsedCustomerTipsLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(IsUseCustomerTipsCheckBox);
